<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <v-row>
      <v-col
        style="max-width: 15rem !important"
        v-for="(table, index) in tables"
        :key="index"
        cols="12"
        md="3"
      >
        <sub-menu-card
          :title="table.title"
          :isSelected="table.name == $route.name"
          :itemKey="table.key"
          @click="subMenuClicked(table.name)"
        />
      </v-col>
    </v-row>
    <template v-if="$route.name == 'serviceLimitation'">
      <service-limitations />
    </template>
    <template v-else-if="$route.name == 'listLimitation'">
      <list-limitations />
    </template>
  </v-container>
</template>

<script>
import math from '@/mixins/math'
import SubMenuCard from '@/components/cards/SubMenuCard'
import ServiceLimitations from './serviceLimitations/ServiceLimitations.vue'
import ListLimitations from './listLimitations/ListLimitations.vue'

export default {
  name: 'RcSesLimitations',
  components: {
    SubMenuCard,
    ServiceLimitations,
    ListLimitations,
  },
  mixins: [math],
  data() {
    return {
      pageloading: false,
      loading: false,
      tables: [
        {
          key: 'services',
          title: 'PASLAUGOS',
          name: 'serviceLimitation',
        },
        {
          key: 'lists',
          title: 'SĄRAŠAI',
          name: 'listLimitation',
        },
      ],
    }
  },
  methods: {
    subMenuClicked(route) {
      this.loading = true
       this.$nextTick(() => {
          this.loading = false
          this.$router.push({ name: route })
        })

    },
  },
}
</script>


<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
</style>

